"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useCallback } from "react";
const STORAGE_KEY = "livescore-favourite-leagues";
interface UseFavouriteLeaguesReturn {
  /** Ordered array of native FansUnited competition IDs (e.g., "fb:c:3"). */
  favouriteIds: string[];
  /** Persist a new ordered list to localStorage. */
  save: (ids: string[]) => void;
  /** False until the first useEffect fires — guards against SSR hydration mismatch. */
  loaded: boolean;
}

/**
 * Reads and writes the user's favourite competition IDs from localStorage.
 * Ordering is preserved — the array order is the display order.
 */
export function useFavouriteLeagues() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [favouriteIds, setFavouriteIds] = useState(t0);
  const [loaded, setLoaded] = useState(false);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) {
            setFavouriteIds(parsed.filter(_temp));
          }
        }
      } catch {}
      setLoaded(true);
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ids => {
      setFavouriteIds(ids);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
      } catch {}
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const save = t3;
  let t4;
  if ($[4] !== favouriteIds || $[5] !== loaded) {
    t4 = {
      favouriteIds,
      save,
      loaded
    };
    $[4] = favouriteIds;
    $[5] = loaded;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp(id) {
  return typeof id === "string";
}